import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetchAuditLogData } from '../audit-log.routes';
import { AuditLogEntry } from '../types';

export function useAuditLogData(
  startDate: Date,
  endDate: Date,
  options?: Omit<
    UseQueryOptions<AuditLogEntry[], Error>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: ['auditLogData', startDate.toISOString(), endDate.toISOString()],
    queryFn: () => fetchAuditLogData(startDate, endDate),
    ...options,
  });
}
